import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import { useTranslation } from 'react-i18next';
import { Box, Tab, Tabs } from '@mui/material';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import fa_thin_arrow_down from "../../assets/images/icons/fa-thin-arrow-down.svg"
import fa_thin_arrow_up from "../../assets/images/icons/fa-thin-arrow-up.svg"
import { SecondaryButton } from '../../components/StyledButtons';

const FAQContent = () => {
    const language = useSelector(selectLanguage)

    const { t } = useTranslation()

    const [tabValue, setTabValue] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const [tabStyles, setTabStyles] = useState({
        customTabStyle: {
            border: "1px solid #565A6F",
            backgroundColor: '#565A6F',
            color: 'white',
            borderRadius: '4px 4px 0 0',
            margin: "0 3px",
        },
        selectedTabStyle: {
            border: "1px solid #565A6F",
            backgroundColor: '#0E2F6C',
            color: 'white',
            borderRadius: '4px 4px 0 0',
            margin: '0 3px',
        }
    });

    const width = window.innerWidth;

    useEffect(() => {
        const handleResize = () => {
            if (width <= 767) {
                setTabStyles({
                    customTabStyle: {
                        border: "1px solid #565A6F",
                        backgroundColor: '#565A6F',
                        color: 'white',
                        borderRadius: '4px 4px 0 0',
                        margin: "0 3px",
                        fontSize: "12px"
                    },
                    selectedTabStyle: {
                        border: "1px solid #565A6F",
                        backgroundColor: '#0E2F6C',
                        color: 'white',
                        borderRadius: '4px 4px 0 0',
                        margin: '0 3px',
                        fontSize: "12px"
                    }
                });
            } else {
                setTabStyles({
                    customTabStyle: {
                        border: "1px solid #565A6F",
                        backgroundColor: '#565A6F',
                        color: 'white',
                        borderRadius: '4px 4px 0 0',
                        margin: "0 3px",
                    },
                    selectedTabStyle: {
                        border: "1px solid #565A6F",
                        backgroundColor: '#0E2F6C',
                        color: 'white',
                        borderRadius: '4px 4px 0 0',
                        margin: '0 3px',
                    }
                });
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
    }, [width]);

    const CustomTabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <div>
                        {children}
                    </div>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function NextArrow(props) {
        const { onClick, classes } = props;
        return (
            <div
                className={classes}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M4.82031 12C4.82031 11.7348 4.92567 11.4804 5.11321 11.2929C5.30074 11.1054 5.5551 11 5.82031 11H19.8203C20.0855 11 20.3399 11.1054 20.5274 11.2929C20.715 11.4804 20.8203 11.7348 20.8203 12C20.8203 12.2652 20.715 12.5196 20.5274 12.7071C20.3399 12.8946 20.0855 13 19.8203 13H5.82031C5.5551 13 5.30074 12.8946 5.11321 12.7071C4.92567 12.5196 4.82031 12.2652 4.82031 12Z" fill="#212121" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M15.1133 7.29279C15.3009 7.10532 15.5552 7 15.8203 7C16.0855 7 16.3398 7.10532 16.5273 7.29279L20.5273 11.2928C20.7148 11.4803 20.8201 11.7346 20.8201 11.9998C20.8201 12.265 20.7148 12.5193 20.5273 12.7068L16.5273 16.7068C16.3387 16.8889 16.0861 16.9897 15.8239 16.9875C15.5617 16.9852 15.3109 16.88 15.1255 16.6946C14.9401 16.5092 14.8349 16.2584 14.8327 15.9962C14.8304 15.734 14.9312 15.4814 15.1133 15.2928L18.4063 11.9998L15.1133 8.70679C14.9259 8.51926 14.8206 8.26495 14.8206 7.99979C14.8206 7.73462 14.9259 7.48031 15.1133 7.29279Z" fill="#212121" />
                </svg>
            </div>
        );
    }

    function PrevArrow(props) {
        const { onClick, classes } = props;
        return (
            <div
                className={classes}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M20 12C20 12.2652 19.8946 12.5196 19.7071 12.7071C19.5196 12.8946 19.2652 13 19 13L5 13C4.73478 13 4.48043 12.8946 4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929C4.48043 11.1054 4.73478 11 5 11L19 11C19.2652 11 19.5196 11.1054 19.7071 11.2929C19.8946 11.4804 20 11.7348 20 12Z" fill="#212121" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.70697 16.7072C9.51944 16.8947 9.26513 17 8.99997 17C8.73481 17 8.4805 16.8947 8.29297 16.7072L4.29297 12.7072C4.1055 12.5197 4.00018 12.2654 4.00018 12.0002C4.00018 11.735 4.1055 11.4807 4.29297 11.2932L8.29297 7.29321C8.48157 7.11105 8.73417 7.01026 8.99637 7.01254C9.25857 7.01482 9.50938 7.11999 9.69479 7.3054C9.8802 7.4908 9.98536 7.74162 9.98764 8.00381C9.98992 8.26601 9.88913 8.51861 9.70697 8.70721L6.41397 12.0002L9.70697 15.2932C9.89444 15.4807 9.99976 15.735 9.99976 16.0002C9.99976 16.2654 9.89444 16.5197 9.70697 16.7072Z" fill="#212121" />
                </svg>
            </div>
        );
    }

    const CustomCard = (props) => {
        return (
            <div className='questions-card'>
                <div>
                    <p className='font-weight-bold'>{props.title}</p>
                </div>
                <div className='pt-20'>
                    <p>{props.content}</p>
                </div>
            </div>
        )
    }

    const settings = {
        centerMode: true,
        infinite: true,
        // centerPadding: "380px",
        slidesToShow: 3,
        speed: 600,
        variableWidth: true,
        swipe: false,
        nextArrow: <NextArrow classes={"questions_next-center-button"} />,
        prevArrow: <PrevArrow classes={"questions_prev-center-button"} />,

        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    swipe: true,
                    infinite: true,
                    arrows: false
                }
            },
        ]
    };


    return (
        <div className='questions container-fluid px-0'>
            <div className='questions_tab col-sm-12 pt-50 px-0'>
                <Box sx={{ borderBottom: 1, borderColor: '#565A6F' }}>
                    <Tabs value={tabValue} onChange={handleChangeTab} centered indicatorColor='none'>
                        <Tab label={t('home-page.home-tab.general.tab-name')} value={0} style={tabValue === 0 ? tabStyles.selectedTabStyle : tabStyles.customTabStyle} {...a11yProps(0)} />
                        <Tab label={t('home-page.home-tab.technology.tab-name')} value={1} style={tabValue === 1 ? tabStyles.selectedTabStyle : tabStyles.customTabStyle} {...a11yProps(1)} />
                        <Tab label={t('home-page.home-tab.industry.tab-name')} value={2} style={tabValue === 2 ? tabStyles.selectedTabStyle : tabStyles.customTabStyle} {...a11yProps(2)} />
                    </Tabs>
                </Box>

                <div className='px-md-0'>
                    <CustomTabPanel value={tabValue} index={0}>
                        <div className='pt-50 questions-container'>
                            <Slider {...settings}>
                                <CustomCard title={t('home-page.home-tab.general.title-1')}
                                    content={t('home-page.home-tab.general.content-1')} />
                                <CustomCard title={t('home-page.home-tab.general.title-2')}
                                    content={t('home-page.home-tab.general.content-2')} />
                                <CustomCard title={t('home-page.home-tab.general.title-3')}
                                    content={t('home-page.home-tab.general.content-3')} />
                                <CustomCardReadmore title={t('home-page.home-tab.general.title-4')}
                                    content={t('home-page.home-tab.general.content-4')} />
                                <CustomCard title={t('home-page.home-tab.general.title-5')}
                                    content={t('home-page.home-tab.general.content-5')} />
                                <CustomCard
                                    title={t('home-page.home-tab.general.title-6')}
                                    content={t('home-page.home-tab.general.content-6')}
                                />
                                <CustomCardReadmore title={t('home-page.home-tab.general.title-7')}
                                    content={t('home-page.home-tab.general.content-7')} />
                            </Slider>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <div className='pt-50 questions-container'>
                            <Slider {...settings} >
                                <CustomCardReadmore title={t('home-page.home-tab.technology.title-1')}
                                    content={t('home-page.home-tab.technology.content-1')} />
                                <CustomCardReadmore title={t('home-page.home-tab.technology.title-2')}
                                    content={t('home-page.home-tab.technology.content-2')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-3')}
                                    content={t('home-page.home-tab.technology.content-3')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-4')}
                                    content={t('home-page.home-tab.technology.content-4')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-5')}
                                    content={t('home-page.home-tab.technology.content-5')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-6')}
                                    content={t('home-page.home-tab.technology.content-6')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-7')}
                                    content={t('home-page.home-tab.technology.content-7')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-8')}
                                    content={t('home-page.home-tab.technology.content-8')} />
                                {language === "en" ?
                                    <CustomCardReadmoreSpecialEn />
                                    :
                                    <CustomCardReadmoreSpecialVi />
                                }
                                <CustomCard title={t('home-page.home-tab.technology.title-10')}
                                    content={t('home-page.home-tab.technology.content-10')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-11')}
                                    content={t('home-page.home-tab.technology.content-11')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-12')}
                                    content={t('home-page.home-tab.technology.content-12')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-13')}
                                    content={t('home-page.home-tab.technology.content-13')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-14')}
                                    content={t('home-page.home-tab.technology.content-14')} />
                                <CustomCard title={t('home-page.home-tab.technology.title-15')}
                                    content={t('home-page.home-tab.technology.content-15')} />
                            </Slider>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={2}>
                        <div className='pt-50 questions-container flex justify-center'>
                            <CustomCard title={t('home-page.home-tab.industry.title-1')}
                                content={t('home-page.home-tab.industry.content-1')} />
                        </div>
                    </CustomTabPanel>
                </div>

            </div>
            <div className='col-sm-12 text-center pt-50'>
                <SecondaryButton>{t('button.see-all-faqs')}</SecondaryButton>
            </div>
        </div>


    )
}

const CustomCardReadmore = (props) => {

    const [isExpanded, setIsExpanded] = useState(false);

    const { t } = useTranslation()
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    return (

        <div className='questions-card-readmore'>
            <div>
                <div className={`questions-card-readmore_content ${isExpanded ? "active" : ""}`}>
                    <p className='font-weight-bold'>{props.title}</p>
                    <p className='pt-20'>
                        {props.content}
                    </p>

                </div>
            </div>
            <div className='read-more-btn' onClick={toggleExpanded}>
                <div className='flex gap-5 justify-center'>
                    <p className='font-weight-semi-bold'>{!isExpanded ? t('button.read-more') : t("button.read-less")}</p>
                    {!isExpanded ? <img src={fa_thin_arrow_down} alt="" /> : <img src={fa_thin_arrow_up} alt="" />}
                </div>
            </div>

        </div>
    )
}

const CustomCardReadmoreSpecialEn = () => {

    const [isExpanded, setIsExpanded] = useState(false);

    const { t } = useTranslation()
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    return (

        <div className='questions-card-readmore'>
            <div>

                <div className={`questions-card-readmore_content ${isExpanded ? "active" : ""}`}>
                    <p className='font-weight-bold'>
                        What is the maximum information that can be securely stored in Qrypto Codes?
                    </p>
                    <p className='pt-20'>
                        Qrypto Secure Code System (QSCS) can be used to generate three types of digitally signed secure codes:
                        <br />
                        <span className='font-weight-semi-bold'>Primary Data Codes (PDC)</span>: These are self-contained codes which encapsulate all the information within the code itself and can be validated off-line with just the public key. Before compression, these codes have a capacity of about 2KB of textual data and the QR image size varies based on the amount of data encapsulated.
                        <br />
                        <span className='font-weight-semi-bold'>Extended Data Codes (EDC)</span>: These codes require connectivity to validate and can contain much more data including attachments like photos and PDFs. The data is stored as encrypted blobs in the Additional Data Repository (ADR) object-store. The decryption key and fingerprint is stored inside the QR content. A unique decryption key is generated for every code. The information can be updated using the update API. The image size of the code is nearly constant.
                        <br />
                        <span className='font-weight-semi-bold'>Hybrid Data Codes (HDC)</span>: These codes combine the features of both the codes above and present PDC information when the validation is offline and EDC information when online. The image size of code is variable and depends upon the amount of PDC data.
                        <br />
                        <br />
                        The data and attachments for EDC and HDC are stored in the ADR. The default ADR is provided by the QSCS on the local disk. Optionally the Qrypto Generator can be configured to use an Object Storage Service (OSS) like Amazon Web Services (AWS) S3 or Microsoft Azure.
                    </p>

                </div>
            </div>
            <div className='read-more-btn' onClick={toggleExpanded}>
                <div className='flex gap-5 justify-center'>
                    <p className='font-weight-semi-bold'>{!isExpanded ? t('button.read-more') : t("button.read-less")}</p>
                    {!isExpanded ? <img src={fa_thin_arrow_down} alt="" /> : <img src={fa_thin_arrow_up} alt="" />}
                </div>
            </div>

        </div>
    )
}

const CustomCardReadmoreSpecialVi = () => {

    const [isExpanded, setIsExpanded] = useState(false);

    const { t } = useTranslation()
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    return (

        <div className='questions-card-readmore'>
            <div>

                <div className={`questions-card-readmore_content ${isExpanded ? "active" : ""}`}>
                    <p className='font-weight-bold'>
                        Thông tin tối đa có thể được lưu trữ an toàn trong Mã Qrypto là gì?
                    </p>
                    <p className='pt-20'>
                        Hệ thống mã bảo mật Qrypto (QSCS) có thể được sử dụng để tạo ba loại mã bảo mật được ký điện tử:
                        <br />
                        <span className='font-weight-semi-bold'>Mã dữ liệu chính (PDC)</span>: Đây là các mã độc lập đóng gói tất cả thông tin trong chính mã đó và có thể được xác thực ngoại tuyến chỉ bằng khóa chung. Trước khi nén, các mã này có dung lượng khoảng 2KB dữ liệu văn bản và kích thước hình ảnh QR thay đổi tùy theo lượng dữ liệu được gói gọn.
                        <br />
                        <span className='font-weight-semi-bold'>Mã dữ liệu mở rộng (EDC)</span>: Các mã này yêu cầu kết nối để xác thực và có thể chứa nhiều dữ liệu hơn, bao gồm các tệp đính kèm như ảnh và tệp PDF. Dữ liệu được lưu trữ dưới dạng các đốm màu được mã hóa trong kho đối tượng Kho lưu trữ dữ liệu bổ sung (ADR). Khóa giải mã và dấu vân tay được lưu trữ bên trong nội dung QR. Một khóa giải mã duy nhất được tạo cho mỗi mã. Thông tin có thể được cập nhật bằng API cập nhật. Kích thước hình ảnh của mã gần như không đổi.
                        <br />
                        <span className='font-weight-semi-bold'>Mã dữ liệu kết hợp (HDC)</span>: Các mã này kết hợp các tính năng của cả hai mã trên và hiển thị thông tin PDC khi xác thực ngoại tuyến và thông tin EDC khi trực tuyến. Kích thước hình ảnh của mã có thể thay đổi và phụ thuộc vào lượng dữ liệu PDC.
                        <br />
                        <br />
                        Dữ liệu và tệp đính kèm cho EDC và HDC được lưu trữ trong ADR. ADR mặc định được cung cấp bởi QSCS trên đĩa cục bộ. Tùy chọn, Trình tạo Qrypto có thể được cấu hình để sử dụng Dịch vụ lưu trữ đối tượng (OSS) như Amazon Web Services (AWS) S3 hoặc Microsoft Azure.
                    </p>

                </div>
            </div>
            <div className='read-more-btn' onClick={toggleExpanded}>
                <div className='flex gap-5 justify-center'>
                    <p className='font-weight-semi-bold'>{!isExpanded ? t('button.read-more') : t("button.read-less")}</p>
                    {!isExpanded ? <img src={fa_thin_arrow_down} alt="" /> : <img src={fa_thin_arrow_up} alt="" />}
                </div>
            </div>

        </div>
    )
}

export default FAQContent